module.exports = __webpack_public_path__ + "img/icon_aside_word1.aa263bf2.svg";